import type { ThemeColors } from '@/domain/models/theme.js';
import { areThemeColorsValid } from '@/presentation/pages/clients/components/client-theme-section.js';
import { isValidEmailDomain } from '@/presentation/pages/clients/components/email-domains-section.js';
import { CLIENT_ABBREVIATION_MAX_LENGTH, CLIENT_NAME_MAX_LENGTH } from '@/shared/constants/client.js';

export type ValidatableClientForm = {
    name: string;
    abbreviation: string;
    emailDomains: string[];
    themeEnabled: boolean;
    themeColors: ThemeColors;
};

export function normalizeEmailDomains(domains: string[]): string[] {
    return domains.map((d) => d.trim().toLowerCase()).filter((d) => d.length > 0);
}

export function validateClientForm(form: ValidatableClientForm): string | null {
    if (!form.name.trim() || !form.abbreviation.trim()) {
        return 'clients.nameAbbrRequired';
    }
    if (form.name.length > CLIENT_NAME_MAX_LENGTH) {
        return 'clients.nameTooLong';
    }
    if (form.abbreviation.length > CLIENT_ABBREVIATION_MAX_LENGTH) {
        return 'clients.abbreviationTooLong';
    }
    const normalizedDomains = normalizeEmailDomains(form.emailDomains);
    if (normalizedDomains.some((d) => !isValidEmailDomain(d))) {
        return 'clients.emailDomains.invalid';
    }
    if (form.themeEnabled && !areThemeColorsValid(form.themeColors)) {
        return 'clients.theme.invalidHex';
    }
    return null;
}
